var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNounLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41.007,
    viewBox: "0 0 41 41.007",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-logout-3114908",
    transform: "translate(-87.505 -17.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M113.476,42.1a1.367,1.367,0,0,0-1.367,1.367v6.835h-8.2V24.334a1.367,1.367,0,0,0-.861-1.271l-7.081-2.83h16.144v12.3a1.367,1.367,0,1,0,2.734,0V18.867a1.367,1.367,0,0,0-1.367-1.367h-24.6a1.37,1.37,0,0,0-.451.082h-.082l-.178.1-.15.137h-.068a1.028,1.028,0,0,0-.246.383v.082a1.365,1.365,0,0,0-.191.588V51.672a1.367,1.367,0,0,0,.861,1.271l13.669,5.468a1.284,1.284,0,0,0,.506.1,1.363,1.363,0,0,0,1.367-1.367v-4.1h9.568a1.367,1.367,0,0,0,1.367-1.367v-8.2a1.367,1.367,0,0,0-1.367-1.367Z",
    transform: "translate(0)",
    fill: "#b1580b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M354.26,199.789a1.413,1.413,0,0,0-.287-1.49l-5.468-5.468a1.373,1.373,0,0,0-1.941,1.941l.971.957V197.9H333.865a1.367,1.367,0,1,0,0,2.734h13.669v2.173l-.971.957a1.373,1.373,0,1,0,1.941,1.941l5.468-5.468a1.37,1.37,0,0,0,.287-.451Z",
    transform: "translate(-225.857 -161.266)",
    fill: "#b1580b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounLogout);
export default __webpack_public_path__ + "static/media/noun-logout.39b5b983431b999d4ad52195f2d4e343.svg";
export { ForwardRef as ReactComponent };